<section class="px-4 websites_managment">
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    *ngIf="loading"
  >
    <mat-spinner diameter="56"></mat-spinner>
    <span>Loading content...</span>
  </div>

  <!-- Error -->
  <div *ngIf="!loading && errorMsg" class="error">
    <mat-icon>error_outline</mat-icon>
    {{ errorMsg }}
    <button translate mat-stroked-button (click)="reload()">Retry</button>
  </div>

  <!-- Content -->
  <ng-container *ngIf="!loading && !errorMsg">
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <h3 translate class="m-0 page_header_title">Websites</h3>
      </div>
      <div *ngIf="actiondata?.create">
        <button
          color="primary"
          mat-button
          translate
          mat-raised-button
          (click)="openAddWebsiteDialog()"
        >
          <i class="fa-solid fa-plus"></i>
          <span translate>Add New Website</span>
        </button>
      </div>
    </div>

    <div class="website-name-list list-container mt-3">
      <div
        *ngIf="websiteNames?.length === 0 && !loading"
        class="empty-data list-container d-flex flex-column justify-content-center align-items-center"
      >
        <i class="fa-solid fa-inbox empty-icon"></i>
        <p translate>No Data found</p>
      </div>

      <div
        *ngIf="websiteNames && websiteNames.length > 0 && !loading"
        class="website-cards-container"
      >
        <mat-card
          *ngFor="let websiteName of websiteNames"
          class="card_container_upper website-card"
        >
          <div class="card_header">
            <div class="title-section">
              <h3 class="website-title">{{ websiteName.name }}</h3>
              <p class="website-url">
                <span translate>View Site:</span>
                <a
                  [href]="websiteName.website_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="$event.stopPropagation()"
                >
                  {{ websiteName.website_url }}
                </a>
              </p>
            </div>
            <!-- <button
              mat-icon-button
              [matMenuTriggerFor]="websiteMenu"
              aria-label="Website actions menu"
              (click)="onMenuClick($event)"
            >
            <i class="fa-solid fa-ellipsis-vertical"></i>
            </button> -->
            <div
              class="action_button cursor_pointer p"
              [matMenuTriggerFor]="websiteMenu"
              aria-label="Website actions menu"
              (click)="onMenuClick($event)"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <mat-menu #websiteMenu="matMenu">
              <p
                class="m-0"
                mat-menu-item
                (click)="viewWebsitePages(websiteName.id)"
              >
                <span translate>View Website Pages</span>
              </p>
              <p
                class="m-0"
                mat-menu-item
                (click)="openEditWebsiteDialog(websiteName)"
              >
                <span translate>Edit Website</span>
              </p>
              <p
                class="m-0"
                mat-menu-item
                (click)="deleteWebsite(websiteName.id)"
              >
                <span translate>Delete Website</span>
              </p>
            </mat-menu>
          </div>

          <mat-card-content>
            <p>{{ websiteName.description }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </ng-container>
</section>
